<template>
<div :class="`wrapper  wrapper--${table_style} m-3 p-2`">
    <div>
        <div class="text-center p-2">
            <h3 class="text-center">ROI per soort</h3>
            <hr>
            <span @click="previousDay"><i class="fas fa-arrow-left"></i></span>
            <input type="date" :value="full_date" @change="handleDateChange" class="mx-2" />
            <span @click="nextDay"><i class="fas fa-arrow-right"></i></span>
        </div>
        <Loading v-if="loading" />
        <div v-else>
            <h4 class="text-center">ROI totaal</h4>
            <div class="p-2 flex">
                <div>

                    <table :class="` table--perweek table__border--${table_style}`">
                        <thead :class="`table__head--${table_style}`">
                            <th class="table__head--text" style="width: 200px;">Naam</th>
                            <th class="table__head--text" style="width: 50px;">Soort</th>
                            <th class="table__head--text table__data--right" style="width: 200px;">ROI *1</th>
                            <th class="table__head--text table__data--right" style="width: 150px;">Totale marge</th>
                            <th class="table__head--text table__data--right" style="width: 200px;">Gem. stadagen</th>
                            <th class="table__head--text table__data--right" style="width: 200px;">Afleveringen</th>

                            <th class="table__head--text table__data--right" style="width: 300px;">Totaal geïnvesteerd vermogen *3</th>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in buyer_roi_soort" :key=item :class="`table__row--color`">
                                <td class="table__cell--default">{{ item.inkopernaam }}</td>
                                <td class="table__cell--default text-center">{{ item.soort }}</td>
                                <td class="table__cell--default text-center">{{ item.roi }} %</td>
                                <td class="table__cell--default table__data--right">€ {{ item.marge }}</td>

                                <td class="table__cell--default table__data--right">{{ item.avg_stadagen }}</td>
                                <td class="table__cell--default table__data--right">{{ item.afleveringen }}</td>

                                <td class="table__cell--default table__data--right">€ {{ item.geinvesteerd_vermogen }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr style="border-bottom: 1px solid gray;">
                                <th class="text-center">TRA</th>
                                <th class="table__cell--default"></th>
                                <th class="table__data--right text-center table__cell--default">{{ TRA_ROI_totals.weighted_avg_roi }} %</th>
                                <th class="table__data--right table__cell--default">€{{ TRA_ROI_totals.totale_marge }}</th>
                                <th class="table__data--right table__cell--default">{{ TRA_ROI_totals.avg_stadagen }}</th>
                                <th class="table__data--right table__cell--default">{{ TRA_ROI_totals.totale_afleveringen }}</th>
                                <th class="table__data--right table__cell--default">€ {{ TRA_ROI_totals.totaal_geinvesteerd_vermogen }}</th>
                            </tr>
                            <tr style="border-bottom: 1px solid gray;">
                                <th class="text-center">TRU</th>
                                <th class="table__cell--default"></th>
                                <th class="table__data--right text-center table__cell--default">{{ TRU_ROI_totals.weighted_avg_roi }} %</th>
                                <th class="table__data--right table__cell--default">€{{ TRU_ROI_totals.totale_marge }}</th>
                                <th class="table__data--right table__cell--default">{{ TRU_ROI_totals.avg_stadagen }}</th>
                                <th class="table__data--right table__cell--default">{{ TRU_ROI_totals.totale_afleveringen }}</th>
                                <th class="table__data--right table__cell--default">€ {{ TRU_ROI_totals.totaal_geinvesteerd_vermogen }}</th>
                            </tr>
                            <tr>
                                <th class="text-center">Totaal</th>
                                <th class="table__cell--default"></th>
                                <th class="table__data--right text-center table__cell--default">{{ buyer_roi_soort_totals.weighted_avg_roi }} %</th>
                                <th class="table__data--right table__cell--default">€{{ buyer_roi_soort_totals.totale_marge }}</th>
                                <th class="table__data--right table__cell--default">{{ buyer_roi_soort_totals.avg_stadagen }}</th>
                                <th class="table__data--right table__cell--default">{{ buyer_roi_soort_totals.totale_afleveringen }}</th>
                                <th class="table__data--right table__cell--default">€ {{ buyer_roi_soort_totals.totaal_geinvesteerd_vermogen }}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="p-2">
                <h4 class="text-center">ROI na voorraadcorrectie</h4>
                <table :class="`w-100 table--perweek table__border--${table_style}`">
                    <thead :class="`table__head--${table_style}`">
                        <th class="table__head--text" style="width: 200px;">Naam</th>
                        <th class="table__head--text" style="width: 50px;">Soort</th>
                        <th class="table__head--text table__data--right" style="width: 200px;">ROI na voorraadcorrectie *2</th>
                        <th class="table__head--text table__data--right" style="width: 150px;">Totale marge</th>
                        <th class="table__head--text table__data--right" style="width: 200px;">Gem. stadagen</th>
                        <th class="table__head--text table__data--right" style="width: 200px;">Totale voorraad</th>
                        <th class="table__head--text table__data--right" style="width: 300px;">Voorraad > 180 dagen</th>
                        <th class="table__head--text table__data--right">Geinvesteerd vermogen correctie</th>
                        <th class="table__head--text table__data--right">Geïnvesteerd vermogen na correctie *4</th>
                    </thead>
                    <tbody>
                        <tr v-for="(item) in buyer_roi_soort" :key=item :class="`table__row--color`">
                            <td class="table__cell--default">{{ item.inkopernaam }}</td>
                            <td class="table__cell--default text-center">{{ item.soort }}</td>
                            <td class="table__cell--default text-center">{{ item.roi_na_correctie }} %</td>
                            <td class="table__cell--default table__data--right">€ {{ item.marge }}</td>
                            <td class="table__cell--default table__data--right">{{ item.avg_stadagen }}</td>
                            <td class="table__cell--default table__data--right">{{ item.voorraad }}</td>
                            <td class="table__cell--default table__data--right">{{ item.voorraad_langstaand }}</td>
                            <td class="table__cell--default table__data--right">€{{ item.voorraad_correctie }}</td>
                            <td class="table__cell--default table__data--right">€ {{ item.geinvesteerd_vermogen_na_correctie }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr style="border-bottom: 1px solid gray;">
                            <th class="text-center">TRA</th>
                            <th class="table__cell--default"></th>
                            <th class="table__data--right text-center table__cell--default">{{ TRA_ROI_totals.weighted_avg_roi_na_correctie }} %</th>
                            <th class="table__data--right table__cell--default">€ {{ TRA_ROI_totals.totale_marge }}</th>
                            <th class="table__data--right table__cell--default">{{ TRA_ROI_totals.avg_stadagen }}</th>
                            <th class="table__data--right table__cell--default">{{ TRA_ROI_totals.totale_voorraad }}</th>
                            <th class="table__data--right table__cell--default">{{ TRA_ROI_totals.totale_voorraad_langstaand }}</th>
                            <th class="table__data--right table__cell--default">€ {{ TRA_ROI_totals.totale_voorraad_correctie }}</th>
                            <th class="table__data--right table__cell--default">€ {{ TRA_ROI_totals.totaal_geinvesteerd_vermogen_na_correctie }}</th>
                        </tr>
                        <tr style="border-bottom: 1px solid gray;">
                            <th class="text-center">TRU</th>
                            <th class="table__cell--default"></th>
                            <th class="table__data--right text-center table__cell--default">{{ TRU_ROI_totals.weighted_avg_roi_na_correctie }} %</th>
                            <th class="table__data--right table__cell--default">€ {{ TRU_ROI_totals.totale_marge }}</th>
                            <th class="table__data--right table__cell--default">{{ TRU_ROI_totals.avg_stadagen }}</th>
                            <th class="table__data--right table__cell--default">{{ TRU_ROI_totals.totale_voorraad }}</th>
                            <th class="table__data--right table__cell--default">{{ TRU_ROI_totals.totale_voorraad_langstaand }}</th>
                            <th class="table__data--right table__cell--default">€ {{ TRU_ROI_totals.totale_voorraad_correctie }}</th>
                            <th class="table__data--right table__cell--default">€ {{ TRU_ROI_totals.totaal_geinvesteerd_vermogen_na_correctie }}</th>
                        </tr>
                        <tr>
                            <th class="text-center">Totaal</th>
                            <th class="table__cell--default"></th>
                            <th class="table__data--right text-center table__cell--default">{{ buyer_roi_soort_totals.weighted_avg_roi_na_correctie }} %</th>
                            <th class="table__data--right table__cell--default">€ {{ buyer_roi_soort_totals.totale_marge }}</th>
                            <th class="table__data--right table__cell--default">{{ buyer_roi_soort_totals.avg_stadagen }}</th>
                            <th class="table__data--right table__cell--default">{{ buyer_roi_soort_totals.totale_voorraad }}</th>
                            <th class="table__data--right table__cell--default">{{ buyer_roi_soort_totals.totale_voorraad_langstaand }}</th>
                            <th class="table__data--right table__cell--default">€ {{ buyer_roi_soort_totals.totale_voorraad_correctie }}</th>
                            <th class="table__data--right table__cell--default">€ {{ buyer_roi_soort_totals.totaal_geinvesteerd_vermogen_na_correctie }}</th>
                        </tr>
                    </tfoot>

                </table>
            </div>

            <div class="mt-2">
                <strong>
                    *1 De formule van ROI = Marge/ Geïnvesteerd vermogen * 100%. De ROI is gebaseerd op de afleveringen vanaf het begin van elk jaar.<br />
                    <br />
                    *2 Bij de ROI-berekening is rekening gehouden met de voorraad > 180 stadagen en het daaruit verwachte rendement.<br />
                    <br />
                    *3 Het totaal geïnvesteerd vermogen is berekend door de totale inkoopwaarde van het voertuig te relateren aan de totale stadagen van het voertuig.<br />
                    <br />
                    *4 Het totaal geinvesteerd vermogen na het optellen van de voorraadcorrectie.
                </strong>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import request from "@/functions/request.js";
import Loading from "@/components/Loading.vue";
import {
    subtractTime,
    addTime
} from "@/functions/date.js";
import moment from "moment";

export default {
    components: {
        Loading
    },
    data: () => ({
        loading: null,
        full_date: null,
        table_style: 200,
        buyer_roi_soort: null,
        buyer_roi_soort_totals: null,
        TRA_ROI_totals: null,
        TRU_ROI_totals: null,
    }),

    created() {
        this.loading = true;
        this.full_date = moment()
        this.getData();
    },

    methods: {
        getData() {
            this.loading = true;
            this.full_date = moment(this.full_date).format('YYYY-MM-DD')

            request(`buyers-roi-soort/${this.full_date}`).then(({
                buyer_roi_soort,
                buyer_roi_soort_totals,
                TRA_ROI_totals,
                TRU_ROI_totals,
            }) => {
                this.buyer_roi_soort = buyer_roi_soort;
                this.buyer_roi_soort_totals = buyer_roi_soort_totals;
                this.TRA_ROI_totals = TRA_ROI_totals;
                this.TRU_ROI_totals = TRU_ROI_totals;

                console.log(TRA_ROI_totals)

                this.loading = false;
            })
        },

        previousDay() {
            this.full_date = subtractTime(1, this.full_date, "days");
            this.getData(this.bu);
        },

        nextDay() {
            this.full_date = addTime(1, this.full_date, "days");
            this.getData(this.bu);
        },

        handleDateChange(event) {
            this.full_date = event.target.value;
            this.getData(this.bu)
        }
    }
}
</script>
